import React from 'react';
import { KView, KText, KImage, PageContext } from '@/component/RtlLayout';
import { convertStyles } from '@kibt/krn-utils';
import { CountDownV2 } from '@kibt/meta-ui-krn';
import { $k18n } from '@/common/i18n';
import flashIcon from '@/assets/icon/flash_icon.png';
import flashIconCountdown from '@/assets/icon/flash_icon_countdown.png';

import SrcStyles from './flashicon.styl';
const Styles = convertStyles(SrcStyles);

const FlashIcon = ({ item, setShowFlash, showFlashCuntDown, showEndIn = false, wrapperStyle = {}, onCountDownEnd = () => {} }) => {
    // 倒计时结束后，结束秒杀相关模块的展示，恢复原价
    const handleCountDownFinish = () => {
        // console.log('handleCountDownFinish');
        setShowFlash(false);
        onCountDownEnd();
    };

    return (
        <PageContext.Provider value={{ Styles }}>
            <KView rtlClassName={'flash-wrap'} style={wrapperStyle}>
                {showFlashCuntDown ? (
                    <KView rtlClassName={'flash-countdown-wrap'}>
                        <KText rtlClassName={'flash-countdown-text'}>
                            {showEndIn ? $k18n({ id: 'k_367076', text: 'End in' }) : $k18n({ id: 'k_367074', text: 'Flash Sale' })}
                        </KText>
                        <KImage rtlClassName={'flash-countdown-image'} source={flashIconCountdown} />
                        <CountDownV2 format={'HH:mm:ss'} leftTime={item.flashSaleEndTime} onEnd={handleCountDownFinish}>
                            {(current) => (
                                <KView style={{ width: 62, justifyContent: 'center', flexDirection: 'row' }}>
                                    <KText rtlClassName={'flash-countdown-time'}>{current.formatteRes.formated}</KText>
                                </KView>
                            )}
                        </CountDownV2>
                    </KView>
                ) : (
                    <KView rtlClassName={'flash-text-wrap'}>
                        <KImage rtlClassName={'flash-image'} source={flashIcon} />
                        <KText rtlClassName={'flash-text'}>{$k18n({ id: 'k_367074', text: 'Flash Sale' })}</KText>
                    </KView>
                )}
            </KView>
        </PageContext.Provider>
    );
};

export default FlashIcon;
